import { render } from "./FormCorrection.vue?vue&type=template&id=de2b45d4&scoped=true"
import script from "./FormCorrection.vue?vue&type=script&lang=js"
export * from "./FormCorrection.vue?vue&type=script&lang=js"

import "./FormCorrection.vue?vue&type=style&index=0&id=de2b45d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2b45d4"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QInput});
